import React, {Component} from 'react'
import LaddaButton, {SLIDE_UP} from '../LaddaButton'
import * as UrlHelpers from '../../helpers/urlHelpers'

class AddWall extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCreatingWall: false,
    }
    this.handleCreateWall = this.handleCreateWall.bind(this)
    this.handleWallNameChange = this.handleWallNameChange.bind(this)
    this.handleWallImageChange = this.handleWallImageChange.bind(this)
    this.handleWallHoldsChange = this.handleWallHoldsChange.bind(this)
  }

  handleCreateWall(e) {
    e.preventDefault()
    let name = this.state.newWallName.toLowerCase()
    let id = name.toLowerCase()
    let wallUrl
    let holdsUrl
    this.setState({
      isCreatingWall: true,
    })

    // Create a root reference
    var storageRef = window.firebaseStorage.ref()
    const docRef = window.firebaseDb.collection('gyms').doc(this.props.gym.id)

    // TODO: make this secure
    let wallId = this.state.newWallName.toLowerCase()
    let wallDir = UrlHelpers.getWallDir(this.props.gym.key, wallId)
    var wallImageRef = storageRef.child(wallDir + '/wall.jpg')
    var wallHoldsRef = storageRef.child(wallDir + '/holds.json')
    let wallPromise = wallImageRef
      .put(this.state.newWallImageFile)
      .then(function (snapshot) {
        console.log('Uploaded newWallImageFile!')
        return snapshot.ref.getDownloadURL()
      })
      .then(function (downloadUrl) {
        wallUrl = downloadUrl
      })
    let holdsPromise
    if (this.state.newWallHoldsFile) {
      holdsPromise = wallHoldsRef
        .put(this.state.newWallHoldsFile)
        .then(function (snapshot) {
          console.log('Uploaded newWallHoldsFile!')
          // holdsUrl = snapshot.metadata.downloadURLs[0]
          return snapshot.ref.getDownloadURL()
        })
        .then(function (downloadUrl) {
          holdsUrl = downloadUrl
        })
    } else {
      holdsPromise = new Promise((resolve, reject) => {
        console.info('No holds file')
        resolve(true)
      })
    }
    Promise.all([wallPromise, holdsPromise]).then(() => {
      let newWalls = Object.assign({}, this.state.walls)
      newWalls[id] = {
        name: name,
        id: id,
        wallUrl: wallUrl,
        holdsUrl: holdsUrl || false,
      }
      docRef.set({walls: newWalls}, {merge: true}).then(() => {
        this.setState({
          isCreatingWall: false,
        })
      })
    })
  }
  handleWallNameChange(e) {
    this.setState({
      newWallName: e.target.value,
    })
  }

  handleWallImageChange(e) {
    let files = e.target.files
    let file = files && files[0]
    if (!file) {
      console.info('no holds file')
      return
    }

    if (!file.type.startsWith('image/')) {
      return
    }

    var reader = new FileReader()
    var dataUrl
    reader.onload = () => {
      dataUrl = reader.result
      this.setState({
        newWallImageDataUrl: dataUrl,
        newWallImageFile: file,
      })
    }
    reader.readAsDataURL(file)
  }

  handleWallHoldsChange(e) {
    let files = e.target.files
    let file = files && files[0]
    if (!file) {
      console.info('no holds file')
      return
    }

    var reader = new FileReader()
    var dataUrl
    reader.onload = () => {
      dataUrl = reader.result
      this.setState({
        newWallHoldsDataUrl: dataUrl,
        newWallHoldsFile: file,
      })
    }
    reader.readAsDataURL(file)
  }

  render() {
    return (
      <form style={{maxWidth: '400px'}}>
        <div className="form-group">
          <h1>Add a new wall</h1>
          <label>Wall Name</label>
          <div className="input-wrapper">
            <input
              placeholder="Wall Name"
              onChange={this.handleWallNameChange}></input>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="new-wall-image-input" className="black">
            Select Image
            <img
              alt="not found"
              src={this.state.newWallImageDataUrl || '/wall_placeholder.jpg'}
              style={{width: '100%', display: 'block'}}
            />
          </label>
          <input
            id="new-wall-image-input"
            style={{display: 'none'}}
            type="file"
            onChange={this.handleWallImageChange}></input>
        </div>

        <div className="form-group">
          <label htmlFor="new-wall-holds-input" className="black">
            If you have a "holds.json" file please add it here. Otherwise
            ignore.
          </label>
          <input
            id="new-wall-holds-input"
            style={{display: 'none'}}
            type="file"
            onChange={this.handleWallHoldsChange}></input>
        </div>
        <LaddaButton
          loading={this.state.isCreatingWall}
          onClick={this.handleCreateWall}
          data-color="mint"
          data-style={SLIDE_UP}
          data-spinner-color="#ddd"
          style={{
            display: 'inline',
            width: '50%',
            borderRadius: '0',
            borderWidth: '0',
          }}>
          Save
        </LaddaButton>
        <LaddaButton
          onClick={this.props.cancel}
          data-color="#eee"
          data-style={SLIDE_UP}
          data-spinner-color="#ddd"
          style={{
            display: 'inline',
            width: '50%',
            borderRadius: '0',
            border: 'none',
            borderLeft: '1px solid white',
          }}>
          Cancel
        </LaddaButton>
      </form>
    )
  }
}

export default AddWall



// WEBPACK FOOTER //
// ./src/components/walls/AddWall.jsx